<template>
  <div class="delivery-bill d-flex flex-center">
    <div class="print-2023" v-if="loaded">
      <div class="main-info">
        <el-row :gutter="20">
          <el-col :span="13">
            <div>
              <div class="item-90">
                <span class="title">Tên trường</span>
                <span class="data">: {{ modelData.school_text }}</span>
              </div>
              <div class="item-90">
                <span class="title">Tên lớp</span>
                <span class="data">: {{ modelData.code }}</span>
              </div>
              <div class="item-90">
                <span class="title">Hệ đào tạo</span>
                <span class="data">: {{ trainingSystem(modelData.level_text) }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="11">
            <div>
              <div class="item-90">
                <span class="title">Trình độ đào tạo</span>
                <span class="data">: {{ schoolLevel(modelData.level_text, modelData.school_text) }}</span>
              </div>
              <div class="item-90">
                <span class="title">Số lượng học sinh</span>
                <span class="data">: {{ modelData.count_user_current }}</span>
              </div>
              <div class="item-90">
                <span class="title">Tên giảng viên</span>
                <span class="data">: {{ modelData.teachter_text }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- cao đẳng -->
      <template>
        <div>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="table-common">
                <table>
                  <tr>
                    <th style="width: 40px;">STT</th>
                    <th style="width: 200px;">Tên học viên</th>
                    <th>Mã số sinh viên theo lớp</th>
                    <th>Email</th>
                    <th style="width: 80px;">Điểm trung bình</th>
                  </tr>

                  <!-- content -->
                  <tr v-for="(item, i) in listStudent.data_result" :key="i">
                    <template>
                        <td>{{ i + 1 }}</td>
                        <td class="text-left">{{ listStudent.data_result[i].user_name }}</td>
                        <td>{{ listStudent.data_result[i].user_code }}</td>
                        <td>{{ listStudent.data_result[i].user_email }}</td>
                        <td>{{ listStudent.data_result[i].average_score }}</td>
                    </template>
                  </tr>
                  <!-- end content -->
                </table>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <!-- cao đẳng -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import {head} from 'lodash'
export default {
  name: 'ShowStudentListPrint',
  metaInfo () {
    return {
      title: 'Danh sách học viên'
    }
  },
  data () {
    return {
      loaded: false,
      loading: false,
      canSubmit: true,
      modelData: {},
      listStudent: []
    }
  },
  mounted () {
    this.fetchModel()
    this.fetchDatabaseModel()
    setTimeout(() => {
      this.printStudentList()
    }, 1500)
  },
  computed: {

  },
  methods: {
    printStudentList () {
      window.print()
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-pros-index', text: 'Lớp học' },
        { name: 'class-pros-show-list-user', id: this.$route.params.id },
        { name: 'class-pros-update1', text: 'Xem kết quả thi' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({ name: 'class-pros-show', params: { id: this.$route.params.id } })
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('class-pros/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            this.loaded = true
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            this.loaded = true
            break
        }
      })
    },
    fetchDatabaseModel () {
      this.loading = true
      axios.post('class-pros/show-list-user/' + this.$route.params.id).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.listStudent = response.data
            break
          case 404:
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    trainingSystem (value) {
      if (value && value.toLowerCase().includes('liên thông')) {
        return 'Liên Thông'
      }
      if (value && value.toLowerCase().includes('văn bằng 2')) {
        return 'Văn Bằng 2'
      }
      return 'Chính Quy'
    },
    schoolLevel (value, value2) {
      if (value && value.toLowerCase().includes('trung cấp')) {
        return 'TRUNG CẤP'
      }
      if (!value.toLowerCase().includes('trung cấp') && !value.toLowerCase().includes('cao đẳng')) {
        if (value2 && value2.toLowerCase().includes('trung cấp')) {
          return 'TRUNG CẤP'
        }
        if (value2 && value2.toLowerCase().includes('cao đẳng')) {
          return 'CAO ĐẲNG'
        }
      }
      return 'CAO ĐẲNG'
    },
    formatPoint (number) {
      let point = parseFloat(number)
      if (isNaN(point)) {
        return ''
      }
      return Math.round(number * 10) / 10
    },
    isNumber (value) {
      if (Number.isNaN(Number.parseFloat(value))) {
        return false
      }
      return true
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  padding: 10px 5px;
  text-align: center;
  color: #000728;
}

.delivery-bill th {
  /*background: #767676;*/
  color: #000;
  padding: 10px 0px;
}

td {
  border: 1px solid #000;
}

th {
  border: 0.1px solid #000;
}

.huhu {
  text-align: left;
  padding-left: 10px;
}

.table-common {
  padding-top: 20px;
  padding-bottom: 20px;
  max-height: 580px;
}

.table-common table {
  height: 100%;
}

.print-2023 {
  margin-top: 20px;
  width: 1000px;
}

.name-school span {
  text-transform: uppercase;
  font-variant: 15px;
  font-weight: bold;
  color: #000;
  margin-bottom: 5px;
}

.name-vn span {
  text-transform: uppercase;
  font-variant: 15px;
  font-weight: bold;
  color: #000;
  margin-bottom: 5px;
}

.name-vn span.text-2 {
  text-transform: inherit;
  font-weight: bold;
}

.line-0999 {
  height: 2px;
  width: 142px;
  border-bottom: 1px solid #000;
  display: inline-block;
}
.line-09991 {
  height: 1px;
  width: 100%;
  display: inline-block;
  position: relative;
}
.line-09991::after {
  content: "";
    position: absolute;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 50%;
    border-bottom: 1px solid #000;
}

.main-title-999 {
  font-size: 30px;
  text-transform: uppercase;
  margin-top: 40px;
  margin-bottom: 15px;
  font-weight: bold;
}

.main-info .title {
  min-width: 120px;
  display: inline-block;
  font-size: 15px;
}

.main-info .data {
  font-weight: bold;
  color: #000;
  font-size: 15px;
}

.total-score span {
  font-weight: bold;
  color: #000;
  font-size: 17px;
}

.total-score .text-2 {
  margin-left: 150px;
}

.sign-19231 .addresss {
  margin-bottom: 10px;
  font-style: italic;
  font-weight: 400;
}

.sign-19231 .name {
  text-transform: uppercase;
  color: #000;
  font-weight: bold
}

td,
th {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

.table-common {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.main-title-999 {
  font-size: 25px !important;
}

.text-uppercase {
  text-transform: uppercase;
}

.no-border {
  border: none;
  width: fit-content;
}

.no-border tr,
.no-border td {
  border: none;
}
.text-left {
  text-align: left !important;
}
.name-school {
  max-width: fit-content;
}
.name-wrap {
  position: relative;
}
.name-vn {
  position: absolute;
  top: 0;
  width: 100%;
  height: 51px;
  margin-left: 40px;
}
.name_vn_son {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
}
.item-90 span {
  font-weight: bold;
    color: #000;
    font-size: 16px;
}
.text-nowrap-mod {
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/class-pros/ShowStudentListPrint.vue